const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deletePayment = async (paymentId) => {
    const token = localStorage.getItem('token');

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/lead/leads/payments/${paymentId}`,
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }

        // some APIs return empty body on DELETE (204 No Content)
        // try parsing only if response has content
        let data = null;
        const text = await response.text();
        if (text) {
            data = JSON.parse(text);
        }

        return data;
    } catch (error) {
        throw error;
    }
};